import React, {
    createContext,
    useState,
    useContext,
    useCallback,
} from "react";
import { getApiInstance } from "../utils/api";
import { useZone } from "./ZoneContext";
import {
    puedeVerAdministracion,
    puedeVerObrasMenores,
    rolDelToken,
    usuarioDelToken,
} from "../utils/permisos";

const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
    const [searchElements, setSearchElements] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { selectedZone } = useZone();

    const fetchAllData = useCallback(async () => {

        setLoading(true);
        setError(null);

        setSearchElements([]);

        const api = getApiInstance();

        /* Productores e intermediarios son datos de Administración: el
           Intermediario no los ve en el menú, así que tampoco en el buscador. */
        const verAdministracion = puedeVerAdministracion(rolDelToken());
        /* Obras menores, solo donde sale en el menú (Europa). */
        const verObrasMenores = puedeVerObrasMenores(usuarioDelToken());
        const sinDatos = Promise.resolve({ data: [] });

        try {
            const [
                obrasResponse,
                gestoresResponse,
                intermediariosResponse,
                obrasMenoresResponse,
                productoresResponse,
            ] = await Promise.all([
                api.get(
                    `/api/Obra/GetObras/es`
                ),
                api.get(
                    `/api/Proveedores/GetProveedores`
                ),
                verAdministracion
                    ? api.get(`/api/Intermediarios/GetIntermediarios`)
                    : sinDatos,
                verObrasMenores
                    ? api.get(`/api/ObraMenor/GetObrasMenoresFromUser`)
                    : sinDatos,
                verAdministracion
                    ? api.get(`/api/Productores/GetProductores`)
                    : sinDatos,
            ]);

            const elementosDict = {
                centroProductor: obrasResponse.data,
                gestores: gestoresResponse.data,
                intermediarios: intermediariosResponse.data,
                obrasMenores: obrasMenoresResponse.data,
                productor: productoresResponse.data,
            };

            setSearchElements(elementosDict);
        } catch (err) {
            setError(
                "No se han podido cargar los datos. Vuelve a intentarlo más tarde."
            );
            console.error("Error al cargar los datos:", err);
        } finally {
            setLoading(false);
        }
    }, []);

    const value = {
        searchElements,
        loading,
        error,
        fetchAllData,
    };

    return (
        <SearchContext.Provider value={value}>
            {children}
        </SearchContext.Provider>
    );
};

export const useSearch = () => {
    const context = useContext(SearchContext);
    if (context === undefined) {
        throw new Error("useSearch debe ser usado dentro de un SearchProvider");
    }
    return context;
};
